import ExaminationDiagnosisBody from './examination-diagnosis-body';

export default ExaminationDiagnosisBody;
